// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import { getUtk } from 'usage-tracker-core/common/defaultTrackers';

// __hs_cookie_cat_pref value comes in this format e.g: 1:true,2:false,3:false
// 1 = Analytics
// 2 = Advertisement
// 3 = Functionality

export const hasAcceptedCookies = () => {
  if (!getUtk()) {
    return false;
  }
  const cookiePref = Cookies.get('__hs_cookie_cat_pref');
  const optOut = Cookies.get('__hs_opt_out');
  return cookiePref && cookiePref.includes('1:true') || optOut === 'no';
};